import { postRestURL } from "../utils/constants/constants";
import { backendURL } from "../utils/constants/constants";

export async function getMyInfluencerAccountData({ token }) {
    try {
        const response = await fetch(`${backendURL}/influencer/findByToken`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getMyCompanyAccountData({ token }) {
    try {
        const response = await fetch(`${backendURL}/company/findByToken`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getSecurityQuestions() {
    try {
        const response = await fetch(`${postRestURL}/securityquestion`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}


export async function getInfluencerNameToVerified({ userName }) {
    try {
        const response = await fetch(`${postRestURL}/influencer?username=eq.${userName}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getCompanyNameToVerified({ userName }) {
    try {
        const response = await fetch(`${postRestURL}/company?username=eq.${userName}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}


export async function getInfluencerEmailToVerified({ email }) {
    try {
        const response = await fetch(`${postRestURL}/influencer?deleted=eq.0&mail=eq.${email}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}


export async function getCompanyEmailToVerified({ email }) {
    try {
        const response = await fetch(`${postRestURL}/company?deleted=eq.0&mail=eq.${email}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}


export async function postEditUserDataInfluencer({ body, token }) {
    try {
        const response = await fetch(`${backendURL}/influencer/update`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(body)
        });
        const data = await response.json();
        return data;
    } catch (e) {
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}


export async function putPasswordInfluencer({ body, token }) {
    try {
        const response = await fetch(`${backendURL}/influencer/resetPassword`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(body)
        });
        const data = await response.json();
        //window.alert('Metodo influencer/resetPassword')
        return data;
    } catch (e) {
        throw (e);
    }
}


export async function putEditUserDataCompany({ body, token }) {
    try {
        const response = await fetch(`${backendURL}/company/update`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(body)
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}


export async function putPasswordCompany({ body, token }) {
    try {
        const response = await fetch(`${backendURL}/company/resetPassword`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(body)
        });
        const data = await response.json();
        //window.alert('Metodo company/resetPassword')
        return data;
    } catch (e) {
        throw (e);
    }
}


export async function getPublicDataInfluencer({ id }) {
    try {
        const response = await fetch(`${postRestURL}/rpc/getpublicpage?usuario=${id}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getPublicDataCompany({ id }) {

    try {
        const response = await fetch(`${postRestURL}/rpc/getpublicpagecompany?usuario=${id}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}


export async function getResetPassword({ email }) {

    try {
        const response = await fetch(`${backendURL}/resetpassword/mail?mail=${email}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function putNewPassword({ passwordBody, userType, token }) {

    try {
        const response = await fetch(`${backendURL}/resetpassword/change/${userType}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(passwordBody)
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getDeleteAccount({ userType, token }) {

    try {
        const response = await fetch(`${backendURL}/deleteaccount/mail/${userType}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getCheckEmailAvailability({ email }) {

    try {
        const response = await fetch(`${postRestURL}/rpc/checkemailavailability?user_email=${email}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}